import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { LineChart, ResponsiveContainer, ScatterChart, XAxis, YAxis } from 'recharts';
import { API_URL } from '../../../config/constants';
import DDChart from './DDChart';
import HistoryChart from './HistoryChart';
import './DetailedDataPenel.scss';

function DetailedDataPenel({ grpIdx, dataClass, grpName, indexName, valView, sumDsId, stdVal }) {
    const [detailedData, setDetailedData] = useState(null);
    const [historyData, setHistoryData] = useState([]);
    const [historyChartData, setHistoryChartData] = useState([]);

    function getDecision(dataArr) {
        if (dataArr.length > 0) {
            const lastData = dataArr[dataArr.length - 1];
            const { count, dataId, ...rest } = lastData;
            const dataKeys = Object.keys(rest);
            let isAlright = true;
            if (dataClass === '치수') {
                isAlright = dataKeys.some((keyName, i) => {
                    if (stdVal[i][0] === 'None') {
                        return true;
                    } else {
                        const differ = lastData[keyName] - stdVal[i][0];
                        return differ >= stdVal[i][1] && differ <= stdVal[i][2];
                    }
                })
            } else {
                isAlright = dataKeys.every((keyName, i) => {
                    if (stdVal[i][0] === 'None') {
                        return true;
                    } else {
                        const differ = lastData[keyName] - stdVal[i][0];
                        return differ >= stdVal[i][1] && differ <= stdVal[i][2];
                    }
                })
            }
            return isAlright ? 'OK' : 'NG';
        } else {
            return 'OK';
        }
    }
    function printDecision(decision) {
        switch (decision) {
            case 'NG':
                return (
                    <div className='decision NG'>
                        <span>불량</span>
                    </div>
                );

            case 'Warning':
                return (
                    <div className='decision Warning'>
                        <span>주의</span>
                    </div>
                );
            default:
                return (
                    <div className='decision OK'>
                        <span>양호</span>
                    </div>
                );
        }
    };

    async function getLatestDetailedData() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getLatestDetailedData`, { tableName: grpName, sumDsId: sumDsId >= 0 ? sumDsId : null, grpIdx });
        setDetailedData(response.data.monitData);
        const resHisData = response.data.historyData.sort((a, b) => a.dataId - b.dataId);
        const lastHisData = resHisData[resHisData.length - 1];
        const lastHisCount = lastHisData?.count ?? 10;
        let hisDataArr = [];
        if (lastHisCount < 10) {
            for (let i = 0; i < lastHisCount; i++) {
                const findingCount = lastHisCount - i;
                const foundData = resHisData.find(el => el.count === findingCount);
                hisDataArr.push(foundData ?? { count: findingCount });
            }
        } else {
            for (let i = 0; i < 10; i++) {
                const findingCount = lastHisCount - i;
                const foundData = resHisData.find(el => el.count === findingCount);
                hisDataArr.push(foundData ?? { count: findingCount });
            }
        }
        setHistoryData(resHisData);
        setHistoryChartData(hisDataArr.sort((a, b) => a.count - b.count));
    };

    useEffect(() => {
        getLatestDetailedData();
        const intervalId = setInterval(() => {
            getLatestDetailedData();
        }, 5000); // 5초 간격

        return () => clearInterval(intervalId);
    }, [grpName])
    return (
        <div className='detailedDataPanel'>
            <ul className='nameNConUl'>
                <li className='nameLi'>
                    <h3 className='psPanelTitle'>
                        {dataClass}
                    </h3>
                </li>
                <li className='conLi'>
                    <div className='panel'>
                        <ul className='panelUl'>
                            <li className='panelLi'>
                                <div className='upperArea'>
                                    <div className='ddChartArea'>
                                        <DDChart
                                            dataClass={dataClass}
                                            ddData={detailedData}
                                        />
                                    </div>
                                    <div className='historyChartArea'>
                                        <HistoryChart
                                            data={historyChartData}
                                        />
                                    </div>
                                    <div className='decisionArea'>
                                        <h4>결과 판정</h4>
                                        {/* 판정 신호등 */}
                                        {
                                            printDecision(getDecision(historyData))
                                        }
                                    </div>
                                </div>
                            </li>
                            <li className='panelLi'>
                                <div className='lowerArea'>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>카운트</th>
                                                {
                                                    // th 10개 출력
                                                    // 카운트가 10 초과면 최근 카운트 10개
                                                    Array.from({ length: 10 }, (v, i) => i).map(index => {
                                                        if (historyData[index]) {
                                                            return (
                                                                <th key={`th_${dataClass}_${index}`}>{historyData[index]["count"]}</th>
                                                            )
                                                        } else {
                                                            const lastCount = !!historyData[historyData.length - 1] ? historyData[historyData.length - 1]["count"] : 1;
                                                            return (
                                                                <th key={`th_${dataClass}_${index}`}>{lastCount + index}</th>
                                                            )
                                                        }
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                // 데이터 종류 개수만큼의 tr 생성
                                                indexName.map((name, idx, array) => {
                                                    const length = array.length;
                                                    if (valView[idx]) {
                                                        return (<tr key={`tr_${dataClass}_${idx}`}>
                                                            <td>
                                                                {/* 데이터이름 */}
                                                                {name}
                                                            </td>
                                                            {
                                                                // th 10개 출력
                                                                // 카운트가 10 초과면 최근 카운트 10개
                                                                Array.from({ length: 10 }, (v, i) => i).map(index => {
                                                                    if (historyData[index]) {
                                                                        return (
                                                                            <td key={`th_${dataClass}_${index}`}>{historyData[index][`data_${grpIdx}_${idx}`].toFixed(2)}</td>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <td key={`th_${dataClass}_${index}`}>{null}</td>
                                                                        )
                                                                    }
                                                                })
                                                                // 카운트가 10 이하면 빈 칸까지 10개 출력

                                                                // 카운트가 10 초과면 최근 10개 출력
                                                            }
                                                        </tr>);
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default DetailedDataPenel;